import {Button, ButtonProps, Mobile, Centered} from '@miro-site/core'

import React, {useEffect, useState} from 'react'
import {TemplateActions} from '../../template-card/templateActions'

export interface StickyUseTemplateMobileProps {
  metadataId: string
  templateActions: TemplateActions
  showOnRefIntersection?: React.MutableRefObject<HTMLElement>
  actionButtonProps?: Partial<ButtonProps>
}

const StickyUseTemplateMobile: React.FC<StickyUseTemplateMobileProps> = ({
  showOnRefIntersection,
  templateActions,
  actionButtonProps,
  metadataId,
}) => {
  const [showStickyButton, setShowStickyButton] = useState<boolean>(false)

  useEffect(() => {
    const isIntersectionObserverSupported =
      'IntersectionObserver' in window && 'IntersectionObserverEntry' in window

    if (isIntersectionObserverSupported && showOnRefIntersection?.current) {
      const element = showOnRefIntersection.current

      const observer = new IntersectionObserver(
        ([entry]) => {
          setShowStickyButton(!entry.isIntersecting)
        },
        {rootMargin: '200px 0px 0px 0px'},
      )

      observer.observe(element)

      return () => {
        observer.unobserve(element)
      }
    }
  }, [])

  if (!showStickyButton) {
    return null
  }

  return (
    <Mobile data-track-place="sticky-use-template">
      <Centered
        $styles={{
          position: 'fixed',
          zIndex: 700,
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        {actionButtonProps ? (
          <Button
            data-track-id="use-template"
            data-template-id={metadataId}
            $buttonType="primary"
            $size="medium"
            $withArrow
            {...actionButtonProps}
          >
            {actionButtonProps.children || templateActions.USE_TEMPLATE}
          </Button>
        ) : null}
      </Centered>
    </Mobile>
  )
}

export default StickyUseTemplateMobile
